module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field form-input"
  }, [(false) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [(_vm.type === 'email') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error && _vm.error.length > 0
    }],
    attrs: {
      "type": "email",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : (_vm.type === 'password') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error && _vm.error.length > 0
    }],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error && _vm.error.length > 0
    }],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon"
  }, [(false) ? _c('i', {
    staticClass: "fa",
    class: ['fa-' + _vm.fa],
    attrs: {
      "name": _vm.fa
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mdi !== undefined) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.mdi))]) : _vm._e()]), _vm._v(" "), (_vm.error && _vm.error.length > 0) ? _c('form-error', {
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f51226c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormInput.vue
// module id = 963
// module chunks = 1